import React from 'react'
import { formattedSeconds, toSeconds } from '../../util/time'
import Button from '@material-ui/core/Button'

export default class Stopwatch extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      inputValue: this.props.value ? formattedSeconds(this.props.value) : '00:00',
      secondsElapsed: this.props.value ? this.props.value : 0,
      lastClearedIncrementer: null
    }
    this.incrementer = null
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        inputValue: nextProps.value ? formattedSeconds(nextProps.value) : '00:00',
        secondsElapsed: nextProps.value ? nextProps.value : 0,
        lastClearedIncrementer: null
      })

      this.incrementer = null
    }
  }

  handleStartClick () {
    this.incrementer = setInterval(() =>
        this.setState({
          secondsElapsed: this.state.secondsElapsed + 1,
          inputValue: formattedSeconds(this.state.secondsElapsed + 1)
        })
      , 1000)
  }

  handleStopClick () {
    clearInterval(this.incrementer)
    this.setState({
      lastClearedIncrementer: this.incrementer
    })
    this.props.onChange(this.state.secondsElapsed)
  }

  handleResetClick () {
    clearInterval(this.incrementer)
    this.setState({
      secondsElapsed: 0,
      inputValue: '00:00'
    })
    this.props.onChange(0)
  }

  handleChangeInput = event => {
    this.setState({secondsElapsed: toSeconds(event.target.value)})
    this.props.onChange(toSeconds(event.target.value))
  }

  render () {
    return (
      <div className="stopwatch">
        <div className="stopwatch-timer">
          <input
            type="text"
            value={this.state.inputValue}
            onChange={event => this.setState({inputValue: event.target.value})}
            onBlur={this.handleChangeInput}
            style={{
              outline: 0,
              margin: '0 auto',
              border: 0,
              textAlign: 'center',
              fontSize: 16
            }}
          />
        </div>

        <div className="stopwatch-actions">
          {(this.state.secondsElapsed === 0 ||
            this.incrementer === this.state.lastClearedIncrementer
              ? <Button className="jr-btn" color="primary" onClick={this.handleStartClick.bind(this)} disabled={this.props.disabled}>Start</Button>
              : <Button className="jr-btn" onClick={this.handleStopClick.bind(this)} disabled={this.props.disabled}>Stop</Button>
          )}

          {(this.state.secondsElapsed !== 0 &&
            this.incrementer === this.state.lastClearedIncrementer
              ? <Button className="jr-btn" color="secondary" onClick={this.handleResetClick.bind(this)} disabled={this.props.disabled}>Reset</Button>
              : null
          )}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/StopWatch/index.js